<svg-icon class="icon-content" [applyClass]="true" [src]="iconUrl" [stretch]="true"
  [svgStyle]="iconStyle">
</svg-icon>
